<template>
    <div class="productListContainer" :style="cssGridRows">
        <div class="productListHeader">
            <input class="searchInputText" type="text" placeholder="商品名 / 商品コード" v-model="searchKeyword">
            <slot name="header-action"></slot>
        </div>
        <div v-if="showSelected" class="selectedProduct">選択中商品 :  {{ selectedProducts.length }}件</div>
        <div class="productList" :style="cssValueListColumn">
            <RecycleScroller
                v-if="dispProducts.length > 0"
                class="productList__list"
                :items="dispProducts"
                key-field="id"
                :item-size="42"
                v-slot="{ item: row }"
            >
                <transition-group class="productList__list-row">
                    <div
                        v-for="product in row.products"
                        :key="product.id"
                        class="productList__item"
                        :class="{ 'selected' : selectedProducts.includes(product.id) }"
                        @click="selectProduct(product)"
                    >
                        <div
                            class="productList__item-major"
                            :class="{ 'majorSelected' : product.is_my_majored }"
                            @click.stop="toggleMajor(product)"
                        >
                            {{ product.is_my_majored ? '★' : '☆' }}
                        </div>
                        <div class="productList__item-name">
                            【{{ product.id }}<Icon v-if="product.is_set_product" title="セット商品">dice-multiple-outline</Icon>】{{ product.name }}
                        </div>
                        <div class="productList__item-action">
                            <slot name="list-item-action" :product="product"></slot>
                        </div>
                    </div>
                </transition-group>
            </RecycleScroller>

            <transition>
                <div v-if="dispProducts.length == 0" class="noData">
                    該当する商品がありません。
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            searchKeyword: '',
            filterKeyword: '',
            productLists: [],
        }
    },
    props: {
        customFilter: Function,
        returnObject: {
            type: Boolean,
            default: false,
        },
        showSelected: {
            type: Boolean,
            default: false,
        },
        listColumn: {
            type: Number,
            default: 3,
        },
        withSetProducts: {
            type: Boolean,
            default: false,
        },
        addFetchParameters: {
            type: Object,
            default: null,
        },
        selectedProducts: Array
    },
    mounted: function() {
        this.axios.get("/api/products", {
            params: {
                with_set_products: this.withSetProducts,
                ...this.addFetchParameters,
            }
        })
        .then((res) => {
            this.productLists = _.map(res.data, product => {
                const name = product.name.toKeyword();
                product._keyword = `${product.id} ${name}`;
                return product;
            });
        });
    },
    methods: {
        
        selectProduct(product) {
            const {_keyword } = product;
            _keyword; // for eslint
            
            if (this.selectedProducts.includes(product.id)) {
                // 選択済み商品から削除
                const index = this.selectedProducts.indexOf(product.id);
                this.selectedProducts.splice(index, 1);
            } else {
                // 選択済み商品に追加
                this.selectedProducts.push(product.id);
            }
        },
        toggleMajor(product) {
            this.axios.post(`/api/products/${product.id}/toggleMajor`)
            .then(res => {
                product.is_my_majored = res.data;
            });
        },
    },
    watch: {
        searchKeyword: _.debounce(function(newVal) {
                this.filterKeyword = newVal.toKeyword();
            },
            500
        ),
    },
    computed: {
        dispProducts: function() {
            let products = this.productLists;

            if (this.customFilter) {
                products = _.filter(products, this.customFilter);
            }

            if (this.filterKeyword) {
                products = _.filter(products, (product) => {
                    return product._keyword.indexOf(this.filterKeyword) > -1;
                });
            }

            products = _.orderBy(products, 'is_my_majored', 'desc');

            // vue-recycle-scroller に渡すために行単位に変換
            return _.chunk(products, this.listColumn).map(row => {
                return {
                    id: row[0].id,
                    products: row,
                };
            });
        },
        cssGridRows: function() {
            if (this.showSelected) {
                return `grid-template-rows: 44px 30px 1fr`;
            } else {
                return `grid-template-rows: 44px 1fr`;
            }
        },
        cssValueListColumn: function() {
            return `--column: ${this.listColumn}`;
        },
    }
}
</script>

<style scoped lang="sass">
.productListContainer
    padding: 0
    height: 100%
    width: 100%
    display: inline-grid
    grid-template-columns: 1fr
    grid-row-gap: 10px
    //grid-template-rows: 44px 30px 1fr
    .productListHeader
        overflow: hidden
        padding: 0
        .searchInputText
            display: block
            float: left
            padding: 10px
            width: 30%
            min-width: 250px
            margin: 2px
            &:focus
                outline: 2px solid $mainColor
    .selectedProduct
        border-bottom: 2px solid #E6E6E6
        color: $grayColor
        font-size: 1.5rem
        height: 30px
        margin: 0
        padding: 7px
        width: 30%
        min-width: 250px
    .productList
        color: $grayColor
        font-size: 1.5rem
        overflow-y: scroll
        margin: 0
        padding: 0
        display: contents
        --column: 4
        &__list-row
            display: flex
            flex-wrap: wrap
            .productList__item
                overflow: hidden
                display: inline-flex
                align-items: center
                margin: 2px
                padding: 7px 2px
                width: calc(100% / var(--column) - 4px)
                height: 40px
                background: #f5f5f5
                white-space: nowrap
                cursor: pointer
                position: relative
                &:hover
                    background: $mainColor
                    color: $whiteColor
                    transition: 0.2s ease-out
                    .productList__item-major:not(.majorSelected)
                        opacity: 1
                .productList__item-major
                    width: 26px
                    height: 26px
                    line-height: 26px
                    font-size: 16px
                    text-align: center
                    display: inline-block
                    opacity: 0
                    transition: all .3s ease 0s
                    &.majorSelected
                        color: #ff9e00
                        opacity: 1
                    &:hover
                        transform: scale(1.6)
                .productList__item-name
                    position: absolute
                    left: 26px
                .productList__item-action
                    position: absolute
                    right: 4px
                &.v-leave-active
                    position: absolute
        .noData
            height: 50%
            display: grid
            place-items: center
        //.v-enter-active, .v-leave-active, .v-move
        //    transition: all 0.4s
        //.v-enter, .v-leave-to
        //    opacity: 0
        .selected
            background: $mainColor
            color: $whiteColor
            opacity: 0.5
</style>
